import { render, staticRenderFns } from "./detailProgress.vue?vue&type=template&id=5891a014&scoped=true&"
import script from "./detailProgress.vue?vue&type=script&lang=js&"
export * from "./detailProgress.vue?vue&type=script&lang=js&"
import style0 from "./detailProgress.vue?vue&type=style&index=0&id=5891a014&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5891a014",
  null
  
)

export default component.exports